export default "__VITE_ASSET__ByiqI6pz__"